import React, { useEffect, useState } from 'react';
import { Oval } from 'react-loader-spinner';
import axios from "axios";
import Pagination from './Pagination';

function Movies() {
  const [movies, setMovies] = useState([]);
  const [pagination, setPagination] = useState(1);
  const [emoji, setEmoji] = useState("");
  const [favourites, setFavourites] = useState([]);
  const onPrev = () => {
    if (pagination > 1)
      setPagination(pagination - 1);
  }
  const onNext = () => {
    setPagination(pagination + 1);
  }

  useEffect(() => {
    axios.get("https://api.themoviedb.org/3/trending/all/day?api_key=bfc2dc001ad661990f954af88f5d31c6&page=" + pagination).then((res) => setMovies(res.data.results),)

  }, [{ pagination }])
  const showFavouriteEmoji=(id)=>{
     let newFav=[...favourites,id]
       setFavourites(newFav);
  }
  const showDislikeEmoji=(id)=>{
    const oldFav=favourites.filter((elem)=>{
      return elem!=id;
    })
    setFavourites(oldFav);
  }
  return (
    <div>
      <div className='text-center font-bold text-3xl mt-7 mb-8'>Trending Movies</div>
      <div className='flex flex-wrap justify-center'>
        {movies.length == 0 ? <div className='flex justify-center'><Oval
          height="80"
          width="80"
          radius="9"
          color="gray"
          secondaryColor="gray" /></div> :
          movies.map((movie) => {
            return <div onMouseOver={() => { setEmoji(movie.id) }} onMouseLeave={() => { setEmoji("") }} key={movie.id} className='mt-20 hover:scale-110 duration-300 ml-4 bg-center bg-cover h-[40vh] border rounded-xl flex relative justify-center items-end flex-wrap w-[200px]' style={{
              backgroundImage: `url(https://image.tmdb.org/t/p/original/t/p/w200${movie.poster_path})`

            }}>

              <div className='bg-gray-900 bg-opacity-60 h-15 p-2 px-3 w-full rounded-b-xl text-center text-white text-xl'>{movie.title || movie.name}</div>
              <div className=' absolute top-2 right-2' style={{ display: emoji == movie.id ? "block" : "none" }}>
                {favourites.includes(movie.id) == false ? <div className='border text-white bg-black p-3 rounded-2xl' onClick={() => { showFavouriteEmoji(movie.id) }}>😍</div> : <div className='border text-white bg-black p-3 rounded-2xl' onClick={() => { showDislikeEmoji(movie.id) }}>❌</div>}
              </div>

            </div>




          })};
      </div>
      <Pagination pagination={pagination} onNext={onNext} onPrev={onPrev}></Pagination>



    </div>
  )
}

export default Movies;